import React from "react";

function TotalProdIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0919 2.02734H1.42523V7.02734H2.25857V16.194C2.25857 16.636 2.43416 17.06 2.74672 17.3725C3.05928 17.6851 3.4832 17.8607 3.92523 17.8607H15.5919C16.0339 17.8607 16.4578 17.6851 16.7704 17.3725C17.083 17.06 17.2586 16.636 17.2586 16.194V7.02734H18.0919V2.02734ZM3.0919 3.69401H16.4252V5.36068H3.0919V3.69401ZM15.5919 16.194H3.92523V7.02734H15.5919V16.194ZM7.25856 8.69401H12.2586C12.2586 9.13604 12.083 9.55996 11.7704 9.87252C11.4578 10.1851 11.0339 10.3607 10.5919 10.3607H8.92523C8.4832 10.3607 8.05928 10.1851 7.74672 9.87252C7.43416 9.55996 7.25856 9.13604 7.25856 8.69401Z"
        fill="#4072C8"
      />
    </svg>
  );
}

export default TotalProdIcon;
